var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('memory-info',{staticClass:"px-1",attrs:{"show-title":false,"capacity":_vm.host.memoryCapacity || 0}}),_c('memory-chart',{staticClass:"mt-2",attrs:{"capacity":_vm.host.memoryCapacity || 0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }